// 获取管理端支持的语言
import zh_cn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import fr from 'element-plus/dist/locale/fr.mjs'

export const getSwitchLang = (langLocal: string) => {
  const langList = ['en', 'zh_CN']
  if (!langList.includes(langLocal)) {
    langLocal = 'en'
  }
  return langLocal
}
// 缩写
export const getAbbrLang = (lang: string) => {
  const langComponent: any = {
    zh_CN: '中',
    en: 'EN',
    fr: 'FR'
  }
  return langComponent[lang] || ''
}
// 获取系统语言
export const getLang = () => {
  let langLocal = localStorage.getItem('LANG') || 'zh_CN'
  const langList = ['en', 'zh_CN']
  if (!langList.includes(langLocal)) {
    langLocal = 'en'
  }
  return langLocal
}
export const getMenuTitle = (data: any, t: (key: string) => string) => {
  const langLocal = localStorage.getItem('LANG') || 'zh_CN'
  const langList = ['en', 'zh_CN']
  if (langList.includes(langLocal)) {
    return data?.meta?.title || ''
  }
  if (data.name) {
    // 其他语言需要匹配语言包
    const slug = data.name.replace(/[./]/g, '_')
    const langKey = 'menus.' + slug
    if (t(langKey) !== langKey) {
      return t(langKey)
    }
  }
  return data?.meta?.title || ''
}
// 菜单对应的面包屑
export const getBreadcrumbTitle = (data: any, t: (key: string) => string) => {
  const langLocal = localStorage.getItem('LANG') || 'zh_CN'
  const langList = ['en', 'zh_CN']
  if (langList.includes(langLocal)) {
    return data?.title || ''
  }
  if (data.name) {
    // 其他语言需要匹配语言包
    const slug = data.name.replace(/[./]/g, '_')
    const langKey = 'menus.' + slug
    if (t(langKey) !== langKey) {
      return t(langKey)
    }
  }
  return data?.meta?.title || ''
}

export const getApplicationTypeTitle = (data: any, t: (key: string) => string) => {
  const langLocal = localStorage.getItem('LANG') || 'zh_CN'
  const langList = ['en', 'zh_CN']
  if (langList.includes(langLocal)) {
    return data?.application_name || ''
  }
  if (data.id) {
    // 其他语言需要匹配语言包
    const langKey = 'applicationTypes.id_' + data.id
    if (t(langKey) !== langKey) {
      return t(langKey)
    }
  }
  return data?.application_name || ''
}
